import Swiper from 'swiper/bundle';

let heroOptions = {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 16,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    effect: 'creative',
    creativeEffect: {
        prev: {
            translate: [0, '-100%', 0],
        },
        next: {
            translate: [0, '100%', 0],
        }
    }
};

(function ($) {
    let swiper;

    function initSwiper() {
        swiper = new Swiper(".stylized-list.swiper-slider", heroOptions);
    }

    function destroySwiper() {
        if (swiper) swiper.destroy();
        swiper = null;
    }

    // the slider works on <=1024 extensions
    function manageSwiper() {
        const isMobile = $(window).width() <= 1024;

        if (isMobile && !swiper) {
            initSwiper();
        } else if (!isMobile && swiper) {
            destroySwiper();
        }

    }

    $(document).ready(manageSwiper);
    $(window).on("resize", manageSwiper);
})(jQuery);